/*
  window.addEventListener('scroll', function() {
    switchIcon();
});

function switchIcon() {
    // Récupérer le premier élément contenant la classe 'header-wrapper'
    var headerElement = document.querySelector('.header-wrapper');
    
    if (headerElement) {
        // Récupérer la liste des classes de l'élément
        var classList = headerElement.classList;
        
        // Vérifier si l'élément a la classe 'p-sticky'
        if (classList.contains('p-sticky')) {
            console.log("black");
        } else {
            console.log("white");
        }
    }
}
*/
let variant_picker = document.getElementsByClassName('select-variant');
let var_init = document.getElementById('variant_name_init');
const sled_chart = document.getElementById('sled_chart').value;
const manufacturerSelect = document.getElementById('pi_sled_manufacturer');
const yearSelectContainer = document.getElementById('year-select-container');
const yearSelect = document.getElementById('pi_sled_year');
const modelSelectContainer = document.getElementById('model-select-container');
const modelSelect = document.getElementById('pi_sled_model');
const packageSelectContainer = document.getElementById('package-select-container');
const packageSelect = document.getElementById('pi_sled_package');
const detailsContent = document.getElementById('pi_sled_details-content');

let data = [];

let lastScrollPosition = 0;

window.addEventListener('scroll', function() {
    switchIconSled();
});

window.addEventListener('load', function() {
    switchIconSled();
});

document.addEventListener('DOMContentLoaded', function () {
        get_sled();
        get_user_sled();
        MageplazaFeed();
        setTimeout(MageplazaFeed, 100);
        setTimeout(MageplazaFeed, 1000);
        setTimeout(MageplazaFeed, 2000);
      });


let getTagBrand = document.querySelectorAll(".pi_tag_brand");
   if (getTagBrand.length > 0) {
       trim_guide_by_brand(localStorage.getItem('sled_manu').toLowerCase());
          for(let i = 0; i < getTagBrand.length; i++) {
            if (getTagBrand[i].getAttribute('tag') == localStorage.getItem('sled_manu').toLowerCase()) {
              getTagBrand[i].classList.add('btn-primary');
              getTagBrand[i].classList.remove('btn-secondary');
            }
            getTagBrand[i].onclick = function () {
              resetBtn(getTagBrand, getTagBrand[i]);
              trim_guide_by_brand(getTagBrand[i].getAttribute('tag')); 
             }
          }
        }


let guideBtn = document.querySelectorAll("[title='#guide']");
if (guideBtn.length > 0) {
  installationLink()
}

function installationLink() {
  var uniqueVlinks = getUniqueVlinks();
  console.log(uniqueVlinks);
  if (document.getElementsByName('id')) {
  var vid = document.getElementsByName('id')[0].value;
  if (vid) {
    variant_guide_link = document.getElementById('guide_link_'+vid).getAttribute('vlink');
    variant_name = document.getElementById('guide_link_'+vid).getAttribute('data-platform') || document.getElementById('guide_link_'+vid).getAttribute('data-plateforme');
    if (variant_guide_link.length == 0) {
    variant_guide_link = getUniqueVlinks(variant_name);
    console.log(variant_guide_link);
    }
    
  }
  var guide_link = document.getElementById('guide_link');
  let guideBtn = document.querySelectorAll("[title='#guide']");
        if (guideBtn) {
          for(let i = 0; i < guideBtn.length; i++) {
            if (guide_link.getAttribute('link') == '' && variant_guide_link == '') {
             //guideBtn[i].style.visibility = 'hidden';
               guideBtn[i].innerHTML = '<strong>'+guide_link.getAttribute('bad')+'</strong>';
             //guideBtn[i].removeAttribute('href');
             //guideBtn[i].removeAttribute('title');
              guideBtn[i].style.pointerEvents = 'none';
              guideBtn[i].style.opacity = '0.4';
            } else {
              //guideBtn[i].style.visibility = 'visible';
              guideBtn[i].style.pointerEvents = 'auto';
              guideBtn[i].style.opacity = '1';
              guideBtn[i].innerHTML = '<strong>'+guide_link.getAttribute('good')+'</strong>';
              if (variant_guide_link == '') {
              guideBtn[i].href = guide_link.getAttribute('link');
              } else {
              guideBtn[i].href = variant_guide_link;
              }
            }

            
          }
        }
  }
}

function getUniqueVlinks(variant_name) {
    var elements = document.querySelectorAll('.unique_pdf');
    var vlink = ''; // Valeur par défaut si aucun match n'est trouvé
    elements.forEach(function(elem) {
        var currentVlink = elem.getAttribute('vlink'); 
        var platform = elem.getAttribute('data-platform') || elem.getAttribute('data-plateforme'); // Vérifie les deux attributs
        if (platform === variant_name && currentVlink) {
            vlink = currentVlink;
        }
    });
    return vlink;
}


function resetBtn(btnlength, elem) {
  if(elem) {
  for(let i = 0; i < btnlength.length; i++) {
  btnlength[i].classList.remove('btn-primary');
  btnlength[i].classList.add('btn-secondary');
  }
  elem.classList.add('btn-primary');
  elem.classList.remove('btn-secondary');
  }
}

function trim_guide_by_brand(selected_tag) {
 console.log(selected_tag);
  var results = document.querySelectorAll('.pi_guide_elem');
  console.log(results.length);
  results.forEach(function(result, index) {
    var tags = result.getAttribute('data-tags');
    
    if (tags) {
      var tag = JSON.parse(tags);
        if (tag.includes(selected_tag)) {
            result.style.display = 'block';
        } else {
            result.style.display = 'none';
        }
    }
  })
}

function MageplazaFeed() {
  var wrapper = document.querySelector('.Mageplaza-MediaItem__Wrapper');
    if (wrapper) {
        wrapper.style.gridTemplateColumns = 'repeat(4, 1fr)';
    }
}
function switchIconSled() {
    let currentScrollPosition = window.scrollY || document.documentElement.scrollTop;
    let targetElement = document.querySelector('.header--transparent .pi_mysled_container');
    if (targetElement) {
        if (currentScrollPosition >= 0 && currentScrollPosition <= 50) {
            targetElement.classList.add('pi_mysled_white');
            targetElement.classList.remove('pi_mysled_dark');
        } else {
            targetElement.classList.add('pi_mysled_dark');
            targetElement.classList.remove('pi_mysled_white');
        }
        lastScrollPosition = currentScrollPosition;
    }
}

function get_sled() {
        let close_btn = document.getElementById('pi_close-selector');
        let next_btn = document.getElementById('pi_sled-next');
        let open_btn = document.getElementsByClassName('pi_mysled_container');
        close_btn.onclick = function () {show_sled_selector()}
        next_btn.onclick = function () {
          show_sled_selector();
          refreshGridResult();
          //activationNotice();
        }
        let findBtn = document.querySelectorAll("[href='#find']");
        if (findBtn) {
          for(let i = 0; i < findBtn.length; i++) {
            findBtn[i].onclick = function () {
              show_sled_selector()
             }
          }
        }
        let elements = document.querySelectorAll(".pi_sled_model");
        for(let i = 0; i < elements.length; i++) {
          if (elements[i].getAttribute('lang') == 'fr') {
            document.getElementsByClassName('pi_mysled')[i].textContent = 'MON GARAGE';
          } else {
            document.getElementsByClassName('pi_mysled')[i].textContent = 'MY GARAGE';
          }
        }
        
        for(let i = 0; i < open_btn.length; i++) {
          open_btn[i].onclick = function () {
          show_sled_selector();
        }
        }
        
}

function show_sled_selector() {
        let element = document.getElementById('pi_sled-selector');
        element.classList.toggle('sled-selector-hide');
        element.classList.toggle('sled-selector-show');
        get_user_sled();
}

function get_user_sled() {
        toggleFindSled();
        document.getElementById('pi_sled-next').style.display = 'none';
        document.getElementById('accessgrid').style.display = 'none';
        let elements = document.querySelectorAll(".pi_sled_model");
        var sled_manu = localStorage.getItem('sled_manu');
        var sled_year = localStorage.getItem('sled_year');
        var sled_model = localStorage.getItem('sled_model');
        var sled_package = localStorage.getItem('sled_package');
        var sled_ski = localStorage.getItem('sled_ski');
        localStorage.getItem('sled_model');
        //alert(sled_manu+'-'+sled_ski);
        for(let i = 0; i < elements.length; i++) {
            if (localStorage.getItem('sled_manu')){
            document.getElementsByClassName('pi_mysled')[i].textContent = sled_manu+' '+sled_model+' '+sled_year;
            }
        }
        //manufacturerSelect.selected = false;
        if (localStorage.getItem('sled_manu') && manufacturerSelect.value == '0') {
        manufacturerSelect.options[0].innerHTML = sled_manu+' '+sled_model+' '+sled_year+' '+sled_package;
        } else {
        manufacturerSelect.options[0].innerHTML = manufacturerSelect.getAttribute('first_option');
        }
        if (document.getElementById('grid-result-make')) {
          document.getElementById('grid-result-make').innerHTML = sled_manu;
          document.getElementById('grid-result-model').innerHTML = sled_model;
          document.getElementById('grid-result-year').innerHTML = sled_year;
          document.getElementById('grid-result-package').innerHTML = sled_package;
          if (sled_manu) {
          renderGridResult();
           // renderGridResultAll();
          } else {
            renderGridResultAll();
          }
        }
  show_compatible(var_init);
  show_compatibile_card(sled_ski,sled_manu);
}

for (var i = 0; i < variant_picker.length; i++) {
variant_picker[i].onclick = function() {
  setTimeout(get_variant_id, 100, 'id', 0);
  setTimeout(installationLink, 100);
}
}

function get_variant_id(name, n) {
  //alert(localStorage.getItem('sled_ski'));
  var vid = document.getElementsByName(name)[0].value;
  //alert(vid);
  var var_elem = document.getElementById('vid_'+vid);
  //alert(var_elem);
  if (!var_elem) {
  var var_elem = document.getElementById('variant_name_init');
  }
  show_compatible(var_elem);
  
  //motion_fill(var_elem, n);
}

function toggleFindSled() {
  var findSledBtn = document.querySelector('.pi_find_btn');
  var sledDetails = document.querySelector('.pi_the_sled_details');
  if (findSledBtn && sledDetails) {
    if (localStorage.getItem('sled_manu')) {
      findSledBtn.style.display = 'none';
      sledDetails.style.display = 'block';
    } else {
      findSledBtn.style.display = 'block';
      sledDetails.style.display = 'none';
    }
  }
}

function getParamSortBy() {
  //alert('getParamSortBy');
var url = new URL('https://qualipieces.com/'+document.location.search);
var sort_by = url.searchParams.get("sort_by");
sortProducts(sort_by);
}

function sortProducts(sort_by) {
    var productList = document.getElementById('productList');
    var products = Array.from(productList.getElementsByClassName('product-in-grid'));
    //var sortValue = document.getElementById('sortSelect').value;
    var sortValue = sort_by; 
    sortSelect = document.getElementById('sortSelect');
    var options = sortSelect.options;
    for (var i = 0; i < options.length; i++) {
    if (options[i].value == sort_by) {
      options[i].selected = true;
      break;
    }
    }
 
    products.sort(function(a, b) {
      var titleA = a.getAttribute('data-title').toLowerCase();
      var titleB = b.getAttribute('data-title').toLowerCase();
      var priceA = parseFloat(a.getAttribute('data-price'));
      var priceB = parseFloat(b.getAttribute('data-price'));

      if (sortValue === 'title-ascending') {
        return titleA.localeCompare(titleB);
      } else if (sortValue === 'title-descending') {
        return titleB.localeCompare(titleA);
      } else if (sortValue === 'price-ascending') {
        return priceA - priceB;
      } else if (sortValue === 'price-descending') {
        return priceB - priceA;
      }
    });

    products.forEach(function(product) {
      productList.appendChild(product);
    });
  
  }


function show_compatibile_card() {
  //alert(sled_ski+'-'+sled_manu);
  var notice = document.querySelectorAll('.compatible_variant_card');
  if (notice.length > 0) {
    for(let i = 0; i < notice.length; i++) {
     notice[i].style.display = 'none';
    }}
  var variants = document.querySelectorAll('.a_variant_card');
  
  if (variants.length > 0) {
    for(let i = 0; i < variants.length; i++) {
     // alert(variants.length);
      show_compatible(variants[i]);
     }
  } 
}

function show_compatible(var_elem) {
  if (var_elem) {
  var sled_manu = localStorage.getItem('sled_manu')?.toLowerCase();
  var sled_year = localStorage.getItem('sled_year');
  var sled_ski = parseInt(localStorage.getItem('sled_ski'));
  var sled_platform = localStorage.getItem('sled_platform')?.toLowerCase();
  var sled_tunnel_type = localStorage.getItem('sled_tunnel_type')?.toLowerCase();
  var sled_tunnel_length = localStorage.getItem('sled_tunnel_length');

  var ski = var_elem.getAttribute('db_ski') ? JSON.parse(var_elem.getAttribute('db_ski')) : null;
  var tag = var_elem.getAttribute('data-tags') ? JSON.parse(var_elem.getAttribute('data-tags')) : null;
  var tunnel_type = var_elem.getAttribute('data-tunnel_type') ? JSON.parse(var_elem.getAttribute('data-tunnel_type')) : null;
  var tunnel_length = var_elem.getAttribute('data-tunnel_length') ? JSON.parse(var_elem.getAttribute('data-tunnel_length')) : null;
  var platform = var_elem.getAttribute('db_platform') ? JSON.parse(var_elem.getAttribute('db_platform')) : null;
  

  var notice = document.querySelectorAll('.pi_sled_match');
  //notice[0] no
  //notice[1] yes
  //notice[2] check
  //notice[3] contact
  
  if (notice.length > 0) {
    notice.forEach((item) => {
    item.style.display = 'none';
}); 
  if (localStorage.getItem('sled_manu')) {
    if (var_elem) {
       if (tag) {
         if (tag.includes('rear') && tag.includes('bumper')) {
           checkRearBumper(var_elem,notice,tag,tunnel_type,tunnel_length,platform,sled_platform,sled_tunnel_type,sled_tunnel_length);
         } else if (tag.includes('front') && tag.includes('bumper')) {
           checkFrontBumper(var_elem,notice,tag,platform,sled_platform);
         } else if (tag.includes('suspension')) {
           checkSuspension(var_elem,notice,tag,platform,sled_platform);
         } else if (tag.includes('carbides') && ski) {
           checkCarbides(var_elem,notice,tag,ski,sled_ski);
         } else if (tag.includes('polaris') || tag.includes('arctic cat') || tag.includes('arcticcat') || tag.includes('yamaha') || tag.includes('ski-doo') || tag.includes('lynx') || tag.includes('skidoo')) {
           checkBrand(var_elem,notice,tag);
         }
        }
     }
    } else {
    notice[2].style.display = 'block'; //check
    }
  }
  }
}

function checkBrand(var_elem,notice,tag) {
  console.log('call');
  var sled_manu = localStorage.getItem('sled_manu')?.toLowerCase();
  if (tag.includes('polaris') || tag.includes('arctic cat') || tag.includes('arcticcat') || tag.includes('yamaha') || tag.includes('ski-doo') || tag.includes('lynx') || tag.includes('skidoo')) {
  if (tag.includes(sled_manu)) {
    notice[1].style.display = 'block'; //yes
    if (document.querySelector('.a_variant_card')) {var_elem.parentElement.style.display='block';}
    } else {
    notice[0].style.display = 'block'; //no
    }
  } else {
    notice[3].style.display = 'block'; //contact
  }
}

function checkRearBumper(var_elem,notice,tag,tunnel_type,tunnel_length,platform,sled_platform,sled_tunnel_type,sled_tunnel_length) {
  console.log('check rear bumper');
  console.log(platform+'-'+tunnel_type+'-'+tunnel_length);
  console.log(sled_platform+'-'+sled_tunnel_type+'-'+sled_tunnel_length);
  if (platform && tunnel_type && tunnel_length) {
  if (platform.includes(sled_platform) && tunnel_type.includes(sled_tunnel_type) && tunnel_length.includes(sled_tunnel_length)) {
    checkBrand(var_elem,notice,tag);
  } else {
    notice[0].style.display = 'block'; //no
  }
  } else {
    notice[3].style.display = 'block'; //contact
  }
}

function checkFrontBumper(var_elem,notice,tag,platform,sled_platform) {
  if (platform) {
  if (platform.includes(sled_platform)) {
    checkBrand(var_elem,notice,tag);
  } else {
    notice[0].style.display = 'block'; //no
  }
  } else {
    notice[3].style.display = 'block'; //contact
  }
}

function checkSuspension(var_elem,notice,tag,platform,sled_platform) {
  if (platform) {
  if (platform.includes(sled_platform)) {
    checkBrand(var_elem,notice,tag);
  } else {
    notice[0].style.display = 'block'; //no
  }
  } else {
    notice[3].style.display = 'block'; //contact
  }
}

function checkCarbides(var_elem,notice,tag,ski,sled_ski) {
  if (ski) {
  if (ski.includes(sled_ski)) {
    checkBrand(var_elem,notice,tag);
  } else {
    notice[0].style.display = 'block'; //no
  }
  } else {
    notice[3].style.display = 'block'; //contact
  }
}


function renderGridResult() {
  document.getElementById('noGridResult').style.display ="none";
  var sled_manu = localStorage.getItem('sled_manu')?.toLowerCase();
  var sled_year = localStorage.getItem('sled_year');
  var sled_ski = parseInt(localStorage.getItem('sled_ski'));
  var sled_platform = localStorage.getItem('sled_platform')?.toLowerCase();
  var sled_tunnel_type = localStorage.getItem('sled_tunnel_type')?.toLowerCase();
  var sled_tunnel_length = localStorage.getItem('sled_tunnel_length');
  document.getElementById('storage_detail').innerHTML = ('<br>Manu: '+sled_manu);
  document.getElementById('storage_detail').innerHTML += ('<br>Year: '+sled_year);
  document.getElementById('storage_detail').innerHTML += ('<br>Ski: '+sled_ski);
  document.getElementById('storage_detail').innerHTML += ('<br>Platform: '+sled_platform);
  document.getElementById('storage_detail').innerHTML += ('<br>Tunnel Type: '+sled_tunnel_type);
  document.getElementById('storage_detail').innerHTML += ('<br>Tunnel Length: '+sled_tunnel_length);
  getParamSortBy();
  var results = document.querySelectorAll('.product-in-grid');
  results.forEach(function(result, index) {
    var ski = result.getAttribute('db_ski') ? JSON.parse(result.getAttribute('db_ski')) : null;
    var tag = result.getAttribute('data-tags') ? JSON.parse(result.getAttribute('data-tags')) : null;
    var tunnel_type = result.getAttribute('data-tunnel_type') ? JSON.parse(result.getAttribute('data-tunnel_type')) : null;
    var tunnel_length = result.getAttribute('data-tunnel_length') ? JSON.parse(result.getAttribute('data-tunnel_length')) : null;
    var platform = result.getAttribute('db_platform') ? JSON.parse(result.getAttribute('db_platform')) : null;
    filterColor(result);
    console.log('platform:'+platform);
    console.log('tag:'+tag);
    console.log('tunnel_length:'+tunnel_length);
    console.log('ski:'+ski);
    if (tag) {
      
      if (tag.includes('rear') && tag.includes('bumper')) {
        filterRearBumper(result,tag,tunnel_type,tunnel_length,platform,sled_platform,sled_tunnel_type,sled_tunnel_length);
      } else if (tag.includes('front') && tag.includes('bumper')) {
        filterFrontBumper(result,tag,platform,sled_platform);
      } else if (tag.includes('suspension')) {
        filterSuspension(result,tag,platform,sled_platform);
      } else if (tag.includes('carbides') && ski) {
        filterCarbides(result,tag,ski,sled_ski);
      } else if (tag.includes('polaris') || tag.includes('arctic cat') || tag.includes('arcticcat') || tag.includes('yamaha') || tag.includes('ski-doo') || tag.includes('lynx') || tag.includes('skidoo')) {
        filterBrand(result,tag);
      } else if (tag.includes('sticker') || tag.includes('beanie') || tag.includes('cap')) {
        result.remove();
      } else {
        //result.remove(); //final
        
      }
    }
  });
  var inlineTableElements = Array.from(results).filter(function(element) {
    return window.getComputedStyle(element).display === 'inline-table';
  });
  if (inlineTableElements.length == 0) {
    document.getElementById('noGridResult').style.display ="block";
  }
}

function filterBrand(result,tag) {
  var sled_manu = localStorage.getItem('sled_manu')?.toLowerCase();
  if (tag.includes('polaris') || tag.includes('arctic cat') || tag.includes('arcticcat') || tag.includes('yamaha') || tag.includes('ski-doo') || tag.includes('lynx') || tag.includes('skidoo')) {
  if (tag.includes(sled_manu)) {
    result.style.display = 'inline-table';
    } else {
    result.remove();
    }
  }
}


function filterCarbides(result,tag,ski,sled_ski) {
  if (ski) {
  if (ski.includes(sled_ski)) {
    filterBrand(result,tag);
  } else {
    result.remove();
  }
  } else {
    result.remove(); //delete 0s
  }
}

function filterFrontBumper(result,tag,platform,sled_platform) {
  if (platform) {
  if (platform.includes(sled_platform)) {
    filterBrand(result,tag);
  } else {
    result.remove();
  }
  } else {
    result.remove(); //delete 0s
  }
}

function filterRearBumper(result,tag,tunnel_type,tunnel_length,platform,sled_platform,sled_tunnel_type,sled_tunnel_length) {
  if (platform && tunnel_type && tunnel_length) {
  if (platform.includes(sled_platform) && tunnel_type.includes(sled_tunnel_type) && tunnel_length.includes(sled_tunnel_length)) {
    filterBrand(result,tag);
  } else {
    result.remove();
  }
  } else {
    result.remove(); //delete 0s
  }
}

function filterSuspension(result,tag,platform,sled_platform) {
  if (platform) {
  if (platform.includes(sled_platform)) {
    filterBrand(result,tag);
  } else {
    result.remove();
  }
  } else {
    result.remove(); //delete 0s
  }
}

function filterColor(result) {
  var color = result.getAttribute('data-color');
  if (!color) {
  color = result.getAttribute('data-couleur');
  }
  if (color == 'black' || color == 'noir' || color == 'product') {
    result.style.display = 'inline-table';
  } else {
    //result.style.display = 'inline-table';
   result.remove(); //delete color variants
  }
}

function renderGridResultAll() {
  var results = document.querySelectorAll('.product-in-grid');
  results.forEach(function(result, index) {
     filterColor(result);
    });
}


function refreshGridResult() {
  if(document.getElementById('allpartpage')) {
    location.reload();
  }
}


// Fetch data from the JSON file
fetch(sled_chart)
    .then(response => response.json())
    .then(jsonData => {
        data = jsonData;

        // Populate manufacturers select
        const manufacturers = [...new Set(data.map(item => item.Manufacturer))].sort();
        manufacturers.forEach(manufacturer => {
            if (manufacturer === "YAMAHA") return;  // Skip YAMAHA
            const option = document.createElement('option');
            option.value = manufacturer;
            option.textContent = manufacturer;
            manufacturerSelect.appendChild(option);
        });
    })
    .catch(error => console.error('Error fetching data:', error));

// Event listener for Manufacturer select
manufacturerSelect.addEventListener('change', () => {
    const selectedManufacturer = manufacturerSelect.value;
    const years = [...new Set(data.filter(item => item.Manufacturer === selectedManufacturer).map(item => item.Year))]
                    .sort((a, b) => b - a); // Sort years in descending order

    yearSelectContainer.style.display = selectedManufacturer ? 'block' : 'none';
    yearSelect.innerHTML = '<option value="">'+yearSelect.getAttribute('first_option')+'</option>';
    modelSelectContainer.style.display = 'none';
    modelSelect.innerHTML = '<option value="">'+modelSelect.getAttribute('first_option')+'</option>';
    packageSelectContainer.style.display = 'none';
    detailsContent.innerHTML = '';

    years.forEach(year => {
        const option = document.createElement('option');
        option.value = year;
        option.textContent = year;
        yearSelect.appendChild(option);
    });
});

// Event listener for Year select
yearSelect.addEventListener('change', () => {
    const selectedManufacturer = manufacturerSelect.value;
    const selectedYear = yearSelect.value;
    const models = [...new Set(data.filter(item => item.Manufacturer === selectedManufacturer && item.Year === parseInt(selectedYear)).map(item => item.Base_model))]
                    .sort(); // Sort models alphabetically

    modelSelectContainer.style.display = selectedYear ? 'block' : 'none';
    modelSelect.innerHTML = '<option value="">'+modelSelect.getAttribute('first_option')+'</option>';
    packageSelectContainer.style.display = 'none';
    detailsContent.innerHTML = '';

    models.forEach(model => {
        const option = document.createElement('option');
        option.value = model;
        option.textContent = model;
        modelSelect.appendChild(option);
    });
});

// Event listener for Model select
modelSelect.addEventListener('change', () => {
    const selectedManufacturer = manufacturerSelect.value;
    const selectedYear = yearSelect.value;
    const selectedModel = modelSelect.value;

    // Filter data for selected options
    const packages = [...new Set(data.filter(item =>
        item.Manufacturer === selectedManufacturer &&
        item.Year === parseInt(selectedYear) &&
        item.Base_model === selectedModel
    ).map(item => String(item.Package)))].filter(package => package && package.trim() !== "").sort(); // Sort packages alphabetically and filter out empty packages

    if (packages.length === 0) {
        // Remove package select if no packages are available
        packageSelectContainer.style.display = 'none';

        // Directly show the details if no packages are available
        const selectedData = data.find(item =>
            item.Manufacturer === selectedManufacturer &&
            item.Year === parseInt(selectedYear) &&
            item.Base_model === selectedModel
        );

        if (selectedData) {
            document.getElementById('pi_sled-next').style.display = 'inline-block';
            document.getElementById('accessgrid').style.display = 'inline-block';
            //alert(`Manufacturer: ${selectedData.Ski}`);
            //alert(`Manufacturer: ${selectedData.Manufacturer}`);
            localStorage.setItem('sled_manu', selectedData.Manufacturer);
            localStorage.setItem('sled_year', selectedData.Year);
            localStorage.setItem('sled_model', selectedData.Base_model);
            localStorage.setItem('sled_package', selectedData.Package);
            localStorage.setItem('sled_ski', selectedData.Ski);
            localStorage.setItem('sled_platform', selectedData.Platform);
            localStorage.setItem('sled_tunnel_type', selectedData.Tunnel_type);
            localStorage.setItem('sled_tunnel_length', selectedData.Tunnel_lenght);
            detailsContent.innerHTML = `
                Manufacturer: ${selectedData.Manufacturer}<br>
                Year: ${selectedData.Year}<br>
                Base Model: ${selectedData.Base_model}<br>
                Original Query: ${selectedData.Original_query}<br>
                Category: ${selectedData.Category}<br>
                Ski: ${selectedData.Ski}<br>
                Platform: ${selectedData.Platform}<br>
                Tunnel: ${selectedData.Tunnel}<br>
                ModPack: ${selectedData.ModPack}<br>
                YrModPack: ${selectedData.YrModPack}<br>
                Full: ${selectedData.Full}<br>
                Extra: ${selectedData.Extra}<br>
                Flag: ${selectedData.Flag}<br>
                Updated: ${selectedData.updated}
            `;
        } else {
            detailsContent.innerHTML = 'No details available';
        }
    } else {
        packageSelectContainer.style.display = 'block';
        packageSelect.innerHTML = '<option value="">'+packageSelect.getAttribute('first_option')+'</option>';
        packages.forEach(package => {
            const option = document.createElement('option');
            option.value = package;
            option.textContent = package;
            packageSelect.appendChild(option);
        });
    }
});

// Event listener for Package select
packageSelect.addEventListener('change', () => {
    const selectedManufacturer = manufacturerSelect.value;
    const selectedYear = yearSelect.value;
    const selectedModel = modelSelect.value;
    const selectedPackage = packageSelect.value;

    // Find selected data details
    const selectedData = data.find(item =>
        item.Manufacturer === selectedManufacturer &&
        item.Year === parseInt(selectedYear) &&
        item.Base_model === selectedModel &&
        String(item.Package) === selectedPackage
    );

    if (selectedData) {
        document.getElementById('pi_sled-next').style.display = 'inline-block';
        document.getElementById('accessgrid').style.display = 'inline-block';
        overridehref(selectedData.Manufacturer);
        //alert(`Manufacturer: ${selectedData.Ski}`);
        //alert(`Manufacturer: ${selectedData.Manufacturer}`);
        localStorage.setItem('sled_manu', selectedData.Manufacturer);
        localStorage.setItem('sled_year', selectedData.Year);
        localStorage.setItem('sled_model', selectedData.Base_model);
        localStorage.setItem('sled_package', selectedData.Package);
        localStorage.setItem('sled_ski', selectedData.Ski);
        localStorage.setItem('sled_platform', selectedData.Platform);
        localStorage.setItem('sled_tunnel_type', selectedData.Tunnel_type);
        localStorage.setItem('sled_tunnel_length', selectedData.Tunnel_lenght);

        
        detailsContent.innerHTML = `
            Manufacturer: ${selectedData.Manufacturer}<br>
            Year: ${selectedData.Year}<br>
            Base Model: ${selectedData.Base_model}<br>
            Package: ${selectedData.Package}<br>
            Original Query: ${selectedData.Original_query}<br>
            Category: ${selectedData.Category}<br>
            Ski: ${selectedData.Ski}<br>
            Platform: ${selectedData.Platform}<br>
            Tunnel: ${selectedData.Tunnel}<br>
            ModPack: ${selectedData.ModPack}<br>
            YrModPack: ${selectedData.YrModPack}<br>
            Full: ${selectedData.Full}<br>
            Extra: ${selectedData.Extra}<br>
            Flag: ${selectedData.Flag}<br>
            Updated: ${selectedData.updated}
        `;
    } else {
        detailsContent.innerHTML = 'No ride found';
    }
});

function overridehref(manu) {
  var href = document.getElementById('accessgrid');

  switch (manu) {
    case 'POLARIS':
      href.href = document.getElementById('polaris-link').value;
      break;
    case 'SKI-DOO':
      href.href = document.getElementById('ski-doo-link').value;
      break;
    case 'LYNX':
      href.href = document.getElementById('lynx-link').value;
      break;
    case 'ARCTIC CAT':
      href.href = document.getElementById('arctic-cat-link').value;
      break;
    default:
      href.href = document.getElementById('all-parts-link').value;
      break;
  }
}
